import React from 'react';
import ReactDOM from 'react-dom/client';
import { 
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client';

import './index.css';

import App from './App';
import About from './routes/about';
import Rmodule from './routes/Rmodule';
import Blog from  './routes/blog'
import BlogContent from "./routes/blogcontent"

import reportWebVitals from './reportWebVitals';

const client = new ApolloClient({
    link: new HttpLink({
      uri: "https://api-ap-southeast-2.hygraph.com/v2/cldl1kqg50pnh01t8drzd08ya/master"
     }),
    cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="about" element={<About />} />
          <Route path="Rmodule" element={<Rmodule />} />
          <Route path="blog" element={<Blog />} />
          <Route 
          path="blog/:postSlug" 
          // loader={({ params }) => {
          //   console.log(params.postSlug);
          // }}
          // action={({ params }) => {}}
          element={<BlogContent/>} 
          />  
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
